import { RoleType, IRoleState, RoleAction } from "../types/roleTypes";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

export default (
  state: IRoleState = initialState,
  { type, payload }: RoleAction
) => {
  switch (type) {
    case RoleType.ROLE_LIST_PENDING:
      return { ...state, ...payload, error: null, isLoading: true };
    case RoleType.ROLE_LIST_SUCCESS:
      return { ...state, ...payload, isLoading: false };
    case RoleType.ROLE_LIST_ERROR:
      return { ...state, ...payload, isLoading: false };

    default:
      return state;
  }
};
